import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { KeycloakService } from 'keycloak-angular';
import { Router } from '@angular/router';
import { brokerRoute } from '../../routes';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class Logout {
  showMenu: boolean = false;
  constructor(
    public modalCtrl: ModalController,
    public keycloak: KeycloakService,
    public router: Router
  ) {}

  public closeThisModal() {
    this.modalCtrl.dismiss({
      dismissed: true
    });
  }

  public logout() {
    this.router.navigate([brokerRoute], { queryParams: { Action: 'logout' } });
  }
}
